import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {playButtonTap} from './PlaySounds';

class TrueFalseScreen extends Component {

  goToGameScreen = () => {
        playButtonTap();
        this.props.history.push('/gamescreen');
    };
    

    render() {
      var trueStatement = "";
      var falseStatement = "";
      var direction = "";
      if(this.props.language === "en"){
         trueStatement = "Each answer you get right will show up as!";
         falseStatement = "Each answer you get wrong will show up as!";
           direction = "ltr";
      }else if(this.props.language === "ur"){
        trueStatement = "اپکا ہر درست جواب کورونا وائرس کے لئے شکست ہے";
        falseStatement = "اپکا ہر غلط جواب کورونا وائرس کی جیت ہے";
          direction = "rtl";
      }
            return(
                <div className = "screen_background">
                  <div className = "popup">
                    <div dir={direction} className = "true_false_option">
                        {trueStatement}<br/>
                        <img src={"/game-skins/build-rev198-B6ETOYjbE/images/virus_happy.png"} alt=""  className = "virus_sad_happy"/>
                    </div>
                    <div dir={direction} className = "true_false_option">
                        {falseStatement}<br/>
                        <img src={"/game-skins/build-rev198-B6ETOYjbE/images/virus_sad.png"} alt="" className = "virus_sad_happy"/>
                    </div> 
                  </div>
                  <img src={"/game-skins/build-rev198-B6ETOYjbE/images_"+this.props.language+"/btn_intro_play.png"} alt="" className="button" onClick = {this.goToGameScreen}/>
                </div>
            )
    }
}

TrueFalseScreen.propTypes = {
  language:PropTypes.string.isRequired
}
const mapStateToProps = state =>({
  language: localStorage.getItem('language',"en")
});
export default connect(mapStateToProps)(TrueFalseScreen);
//export default withRouter(IntroScreen);



// WEBPACK FOOTER //
// ./src/components/TrueFalseScreen.js